import{__require as r}from"../parse/index.js";var e,t;function a(){if(t)return e;t=1;var a=r();return e=function(r,e){var t=e&&Number(e.weekStartsOn)||0,n=a(r),u=n.getDay(),s=(u<t?7:0)+u-t;return n.setDate(n.getDate()-s),n.setHours(0,0,0,0),n}}export{a as __require};
//# sourceMappingURL=index.js.map
